module.exports = __webpack_public_path__ + "img/info.79dc9a60.svg";